const parentType = (inspectionId) => (inspectionId ? 'inspection' : 'workOrder');
export const documentsKey = (inspectionId, workOrderId) => ['documents', parentType(inspectionId), inspectionId || workOrderId];
export const documentsTypeKey = (inspectionId, workOrderId) => ['documentsType', parentType(inspectionId), inspectionId || workOrderId];
